<template>
  <div class="form-wrapper">
    <h2>Edit Unit</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Name</label>
        <input v-model="unit.name" type="text" required />
      </div>

      <div class="form-group">
        <label>Status</label>
        <select v-model="unit.status">
          <option>Active</option>
          <option>Inactive</option>
        </select>
      </div>

      <button type="submit" class="btn btn-gradient">
        <span v-if="loading">Updating...</span>
        <span v-else>Update Unit</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'EditUnitComponent',
  props: ['id'],
  data() {
    return {
      unit: { name: '', status: 'Active' },
      loading: false,
    };
  },
  methods: {
    fetchUnit() {
      this.$store.dispatch('units/getUnit', this.id)
        .then(data => this.unit = data);
    },
    submitForm() {
      this.loading = true;
      this.$store.dispatch('units/updateUnit', { id: this.id, ...this.unit })
        .then(() => this.$router.push({ name: 'Units' }))
        .finally(() => this.loading = false);
    }
  },
  mounted() {
    this.fetchUnit();
  }
};
</script>

<style scoped>
/* Same as AddUnitComponent */
.form-wrapper {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
}
input, select { width: 100%; padding: 8px; border-radius: 5px; border: 1px solid #ccc; margin-bottom: 15px; }
.btn-gradient { background: linear-gradient(135deg, #6a82fb, #fc5c7d); color: #fff; padding: 10px 20px; border-radius: 8px; transition: transform 0.3s; }
.btn-gradient:hover { transform: scale(1.05); }
</style>
